module.exports = __webpack_public_path__ + "media/images/products-img-04-ff5baa7245ccb9556b1d91e2b8d34565.jpg";